import Swal from "sweetalert2";
import Axios from "axios";
const cesde_crm_forms = document.querySelectorAll(".cesde_crm_form form");
const Toast = Swal.mixin({
  toast: true,
  position: "top-right",
  iconColor: "white",
  customClass: {
    popup: "colored-toast",
  },
  showConfirmButton: false,
  timer: 1500,
  timerProgressBar: true,
});

cesde_crm_forms.forEach((cesde_crm_form) => {
  const dateInputs = cesde_crm_form.querySelectorAll('input[type="date"]');
  const emailInputs = cesde_crm_form.querySelectorAll('input[type="email"]');
  const textAreas = cesde_crm_form.querySelectorAll("textarea");
  const hiddenInput = cesde_crm_form.querySelectorAll('input[type="hidden"]');
  const selects = cesde_crm_form.querySelectorAll("select");
  const textInputs = cesde_crm_form.querySelectorAll('input[type="text"]');
  const numberInputs = cesde_crm_form.querySelectorAll('input[type="number"]');
  cesde_crm_form.addEventListener("submit", (e) => {
    e.preventDefault();
    const url = cesde_crm_ajax.admin_ajax;
    const formUrlAction = cesde_crm_form.action;
    const aceptance = cesde_crm_form.querySelector(".aceptar-input");
    const errors = [];
    const inputValidates = (inputs) => {
      inputs.forEach((input) => {
        if (input.value == "" && input.getAttribute("required") == "true") {
          const label = document.querySelector("label[for='" + input.id + "']");
          input.classList.add("alert");
          errors.push(`<br>Campo ${label.textContent} vacio`);
          setTimeout(() => {
            input.classList.remove("alert");
          }, 5000);
        }
        if (input.type == "email") {
          const regex =
            /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
          if (!regex.test(input.value)) {
            const label = document.querySelector(
              "label[for='" + input.id + "']"
            );
            input.classList.add("alert");
            errors.push(`<br>Campo ${label.textContent} invalido`);
            setTimeout(() => {
              input.classList.remove("alert");
            }, 5000);
          }
        }
      });
    };
    if ( !aceptance.checked) {
      console.log('este bucle');
      Toast.fire({
        icon: "error",
        title: "Aceptar Terminos y condiciones del fomulario",
      });
      return null;
    }

    /**
     * Select
     */

    if (selects.length > 0) {
      inputValidates(selects);
    }
    /**
     * text
     */
    if (textInputs.length > 0) {
      inputValidates(textInputs);
    }
    /**
     * date
     */
    if (dateInputs.length > 0) {
      inputValidates(dateInputs);
    }
    /**
     * email
     */
    if (emailInputs.length > 0) {
      inputValidates(emailInputs);
    }
    /**
     * number
     */
    if (numberInputs.length > 0) {
      inputValidates(numberInputs);
    }
    /**
     * textarea
     */
    if (textAreas.length > 0) {
      inputValidates(textAreas);
    }

    /**
     * hidden
     *
     */
    if (hiddenInput.length > 0) {
      hiddenInput.forEach((input) => {
        if (hiddenInput.value == "") {
          Swal.mixin({
            toast: true,
            position: "top-right",
            iconColor: "white",
            customClass: {
              popup: "colored-toast",
            },
            showConfirmButton: false,
          }).fire({
            icon: "warning",
            title: `<h4 style="font-size:0.9rem;color:white;margin-bottom:0;">Alerta!!</h4><p style="font-size:0.7rem;">Algun campo oculta no posee valor o esta incompleto</p>`,
          });
        }
      });
    }

    /**
     * Show erros
     */
    if (errors.length > 0) {
      Swal.mixin({
        toast: true,
        position: "top-right",
        iconColor: "white",
        customClass: {
          popup: "colored-toast",
        },
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      }).fire({
        icon: "error",
        title: `<h4 style="font-size:0.9rem;color:white;margin-bottom:0;">Errores del formulario</h4><div style="font-size:0.7rem;"> ${errors.join()}</div>`,
      });

      return null;
    } else {
      const formData = new FormData();
      const addFormFata = (inputs) => {
        inputs.forEach((input) => {
          formData.append(input.name, input.value);
        });
      };
      if (selects.length > 0) {
        addFormFata(selects);
      }
      if (textInputs.length > 0) {
        addFormFata(textInputs);
      }
      if (hiddenInput.length > 0) {
        addFormFata(hiddenInput);
      }
      if (textAreas.length > 0) {
        addFormFata(textAreas);
      }
      if (numberInputs.length > 0) {
        addFormFata(numberInputs);
      }
      if (emailInputs.length > 0) {
        addFormFata(emailInputs);
      }
      if (dateInputs.length > 0) {
        addFormFata(dateInputs);
      }
       jQuery('.cesde_crm_form .loader').fadeIn()
      Axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": "*",
        },
        data: formData,
      })
        .then((res) => {
         // console.log(res);
          return res.data;
        })
        .then((res) => {
          jQuery('.cesde_crm_form .loader').fadeOut()
          if(document.querySelector('.cesde-modal-operator').classList.contains('active')){
            document.querySelector('.cesde-operator-close').click()
          }
          const newButton = document.createElement('a')
          newButton.setAttribute('href',`${window.location.origin}/registro-exitoso/`)
         // newButton.setAttribute('target','_blank')
          const footer = document.querySelector('footer')
          footer.append(newButton)
          newButton.click()
          cesde_crm_form.reset()
        
        
        });
    }
 
  });
});
